import React from 'react';
import type { TeamTileColors } from '../../cfbBranding/teamVisualResolver';

export type TeamCircleProps = {
  name: string;
  abbreviation: string;
  tileColors: TeamTileColors | null;
};

const TeamCircle: React.FC<TeamCircleProps> = ({ name, abbreviation, tileColors }) => (
  <div data-testid="team-circle" className="flex w-[88px] min-h-11 flex-col items-center gap-1">
    <span
      className="flex h-11 w-11 items-center justify-center rounded-full font-stream-display text-sm font-bold ring-1 ring-stream-line"
      style={{
        backgroundColor: tileColors?.primary ?? '#222838',
        color: tileColors?.onPrimary ?? '#F2F4F8',
      }}
    >
      {abbreviation}
    </span>
    <span className="w-[88px] whitespace-normal text-center font-stream-body text-xs leading-tight text-stream-ink">
      {name}
    </span>
  </div>
);

export default TeamCircle;
